export const helpWithBillingData = [
  {
    Question: `How do I get help with billing issues?`,
    Answer: `Understanding your invoice, updating your payment information, or enrolling in Autopay and Paperless online is easy. 

        Visit our expanded knowledge repository on <a href=’https://www.wm.com/us/en/support/faqs/billing’>billing management</a> to explore all the ways you can manage your bill and payment options.  
        
        Your My WM account now makes it more convenient than ever to: 
        
        <ul><li>Enjoy the convenience of 24 hour access</li> 
        
        <li>Download invoices</li> 
        
        <li>Pay your bill online</li> 
        
        <li>Change or edit your payment method(s)</li> 
        
        <li>Enroll in AutoPay and Paperless</li></ul>`,
  },
]
